import React, { useState, useEffect, useCallback } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { debounce } from 'lodash';
import TextInput from '@/se/components/inputs/TextInput';
import SelectInput from '@/se/components/inputs/SelectInput';
import { withProps } from 'recompose';

const useStyles = makeStyles(theme => ({
  form: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  inputStack: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    '& > *': {
      width: 250,
      minWidth: 150,
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
  },
}));

const DebouncedTextInput = ({ value, onChange, placeholder }) => {
  const [internal, setInternal] = useState(value || '');

  useEffect(() => {
    setInternal(value || '');
  }, [value]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedOnChange = useCallback(
    debounce(val => onChange(val), 300),
    [onChange]
  );

  const onChangeInternal = val => {
    setInternal(val);
    debouncedOnChange(val);
  };

  return <TextInput autoComplete="off" onChange={onChangeInternal} value={internal} placeholder={placeholder} />;
};

const EnabledStatusOptions = {
  all: 'All Sensors',
  enabled: 'Enabled Only',
  disabled: 'Disabled Only',
};

const EnabledStatusSelectInput = withProps({
  placeholder: 'Status',
  options: EnabledStatusOptions,
  isSearchable: false,
  menuWidthFollowContent: false,
  name: 'enabledStatus',
})(SelectInput);

const SensorFilters = ({ value = {}, onChange, isSuperAdmin }) => {
  const classes = useStyles();

  const onFilterChange = key => val => {
    onChange({ ...value, [key]: val });
  };

  const clearAll = () => {
    onChange({ search: '', enabledStatus: isSuperAdmin ? 'all' : 'enabled' });
  };

  return (
    <Box className={classes.form}>
      <Box className={classes.inputStack}>
        <DebouncedTextInput
          value={value.search || ''}
          onChange={onFilterChange('search')}
          placeholder="Search by ID or Location..."
        />
        {isSuperAdmin && (
          <EnabledStatusSelectInput onChange={onFilterChange('enabledStatus')} value={value.enabledStatus || 'all'} />
        )}
      </Box>
      <Box flex="none">
        <Button onClick={clearAll}>Clear</Button>
      </Box>
    </Box>
  );
};

export default SensorFilters;
